import React from 'react';
import { NoDataFound } from '@fabric-ui/components';
import NoAlertsYet from '@fabric-ui/icons/svg/emptyStates/No Alerts yet.svg';
import { refetchingStyle } from '@fabric-ui/theme';
import { Button } from '@mui/material';
import Pluralize from 'pluralize';

export const alertsNoDataFound = ({ projDisplayName, isRefetching, clearAllFilters }) => (
  <NoDataFound
    headline={`No ${Pluralize(projDisplayName)} Found`}
    img={NoAlertsYet}
    style={isRefetching ? { containerStyle: refetchingStyle } : {}}
    callToAction={
      <>
        Try to{' '}
        <Button variant="primaryText" onClick={() => clearAllFilters(false, true)}>
          Clear All filters
        </Button>
      </>
    }
  />
);
